import { Injectable, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { PublicShippingMethodApiService } from '../api/services/public-shipping-method-api.service';
import { CollectionRequestBuilder } from '@web/common';
import { valueOrDefault } from '@web/utils';
import { PublicShippingMethod } from '@web/shared/module/shop';

@Injectable({
  providedIn: 'root',
})
export class PublicShippingMethodDataSourceService {
  private readonly shippingMethodApi = inject(PublicShippingMethodApiService);
  private readonly collectionRequest = inject(CollectionRequestBuilder);

  public fetchShippingMethods(options?: {
    cacheable?: boolean;
  }): Observable<PublicShippingMethod[]> {
    return this.shippingMethodApi
      .fetchCollection({
        request: this.collectionRequest.disablePagination().build(),
        cacheable: valueOrDefault(options?.cacheable, true),
      })
      .pipe(
        map((responses) =>
          responses.items.map(
            (item) =>
              new PublicShippingMethod({
                code: item.code,
                category: item.category,
                description: item.description,
                name: item.name,
                id: item.id,
              }),
          ),
        ),
      );
  }
}
